import * as React from 'react';
import { inject, observer } from 'mobx-react';
import * as styles from './Phonebook.css';
import { NavigatorStore } from '../stores';
import PhonebookService from '../../../services/PhonebookService';
import { IPeopleInfo } from '../../../interfaces/IPeopleInfo';
import { IPeopleProperty } from '../../../interfaces/IPeopleProperty';
import { PeopleCard, IPeopleCardProperties } from './peopleCard/PeopleCard';
import { Helper } from '../../../Helper';
import { IAIcon } from '../../icon/Icon';
import { Environment } from '../../../services/Environment';
import { ConditionalOutput } from '../../../services/ConditionalOutput';
import { LocalizationService } from '../../../services/LocalizationService';
import { IATextField } from '../../textField/TextField';
import { IASkeleton } from '../../skeleton/Skeleton';
import { IASpinner } from '../../spinner/Spinner';
import { IAButton } from '../../button/Button';
import { IAPanel } from '../../panels/Panel';

export interface IProps {
  navigatorStore?: NavigatorStore;
  isShowing: boolean;
}

export interface IState {
  content: IPeopleInfo[];
  searchQuery: string;
  isLoading: boolean;
  loadingMore: boolean;
  hasAllPeople: boolean;
  errorFetching: boolean;
}

@inject('navigatorStore')
@observer
export class Phonebook extends React.Component<IProps, IState> {
  private rowLimit = 50;
  private searchTimeoutId: NodeJS.Timeout | null = null;
  constructor(props) {
    super(props);
    this.state = {
      content: [],
      searchQuery: '',
      isLoading: false,
      hasAllPeople: false,
      loadingMore: false,
      errorFetching: false,
    };
  }

  public componentWillReceiveProps(props: IProps) {
    if (props.isShowing && props.isShowing != this.props.isShowing) {
      this.setState({ searchQuery: "", errorFetching: false });
      this.search("", 0);
    }
  }

  private getPropertiesForPeopleCard = (content: IPeopleProperty[]): IPeopleCardProperties[] => {
    const result: IPeopleCardProperties[] = [];
    content.map((property: IPeopleProperty) => {
      if (property?.property && property?.value) {
        let iconTitle;
        switch (property.property) {
          case 'PreferredName':
            iconTitle = "";
            break;
          case 'WorkEmail':
            iconTitle = 'https://intraactivestorage.blob.core.windows.net/cdn/icons/Mail/SVG/ic_fluent_mail_48_regular.svg';
            break;
          case 'TelefonbogMail':
            iconTitle = 'https://intraactivestorage.blob.core.windows.net/cdn/icons/Mail/SVG/ic_fluent_mail_48_regular.svg';
            break;
          case 'JobTitle':
            iconTitle = 'https://intraactivestorage.blob.core.windows.net/cdn/icons/Star/SVG/ic_fluent_star_48_regular.svg';
            break;
          case 'Department':
            iconTitle = 'https://intraactivestorage.blob.core.windows.net/cdn/icons/Organization/SVG/ic_fluent_organization_48_regular.svg';
            break;
          case 'WorkPhone':
            iconTitle = 'https://intraactivestorage.blob.core.windows.net/cdn/icons/Call/SVG/ic_fluent_call_48_regular.svg';
            break;
          case 'MobilePhone':
            iconTitle = 'https://intraactivestorage.blob.core.windows.net/cdn/icons/Call/SVG/ic_fluent_call_48_regular.svg';
            break;
          default:
            break;
        }
        if (!iconTitle) {
          switch (property.icon) {
            case 'fa-phone-square':
              iconTitle = "https://intraactivestorage.blob.core.windows.net/cdn/icons/Call/SVG/ic_fluent_call_48_regular.svg";
              break;
            case 'fa-envelope-o':
              iconTitle = "https://intraactivestorage.blob.core.windows.net/cdn/icons/Star/SVG/ic_fluent_star_48_regular.svg";
              break;
            case 'fa-map-marker':
              iconTitle = "https://intraactivestorage.blob.core.windows.net/cdn/icons/Location/SVG/ic_fluent_location_48_regular.svg";
              break;
            case 'fa-industry':
              iconTitle = "https://intraactivestorage.blob.core.windows.net/cdn/icons/Building%20Factory/SVG/ic_fluent_building_factory_48_regular.svg";
              break;
            case 'fa-group':
              iconTitle = "https://intraactivestorage.blob.core.windows.net/cdn/icons/People%20Community/SVG/ic_fluent_people_community_28_regular.svg";
              break;
            case 'fa-institution':
              iconTitle = "https://intraactivestorage.blob.core.windows.net/cdn/icons/Building%20Bank/SVG/ic_fluent_building_bank_48_regular.svg";
              break;
            case 'fa-birthday-cake':
              iconTitle = "https://intraactivestorage.blob.core.windows.net/cdn/icons/Food%20Cake/SVG/ic_fluent_food_cake_24_regular.svg";
              break;
            case 'fa-briefcase':
              iconTitle = "https://intraactivestorage.blob.core.windows.net/cdn/icons/Briefcase/SVG/ic_fluent_briefcase_48_regular.svg";
              break;
            case 'fa-flag-o':
              iconTitle = "https://intraactivestorage.blob.core.windows.net/cdn/icons/Flag/SVG/ic_fluent_flag_48_regular.svg";
              break;
            case 'fa-mobile-phone':
              iconTitle = "https://intraactivestorage.blob.core.windows.net/cdn/icons/View%20Desktop%20Mobile/SVG/ic_fluent_view_desktop_mobile_24_regular.svg";
              break;
            case 'fa-star-o':
              iconTitle = "https://intraactivestorage.blob.core.windows.net/cdn/icons/Star/SVG/ic_fluent_star_48_regular.svg";
              break;
            case 'fa-star':
              iconTitle = "https://intraactivestorage.blob.core.windows.net/cdn/icons/Star/SVG/ic_fluent_star_48_filled.svg";
              break;
            case 'fa-soccer-ball-o':
              iconTitle = "https://intraactivestorage.blob.core.windows.net/cdn/icons/Sport%20Soccer/SVG/ic_fluent_sport_soccer_24_regular.svg";
              break;
            default:
              break;
          }
        }
        result.push({
          value: property.value,
          property: property.property,
          classNames: new ConditionalOutput(["IA_credentials_dots"])
            .OnCondition(property.property === "PreferredName", ["IA_credentials_dots", "IA_credential_name"])
            .Last(),
          iconTitle: iconTitle,
          link: property.type,
          iconColor: window.__themeState__?.theme?.themePrimary ? window.__themeState__?.theme?.themePrimary : this.props.navigatorStore.highlightColor,
          templateLink: property.templateLink,
          icon: property.icon
        });
      }
    });
    return result;
  }

  private async search(searchQuery: string, startRow?: number): Promise<void> {
    if (startRow) {
      this.setState({ loadingMore: true });
    } else {
      this.setState({ isLoading: true });
    }
    const row = startRow || 0;
    const resultSource = this.props.navigatorStore.selectedPhonebook.resultSource ? this.props.navigatorStore.selectedPhonebook.resultSource : "";
    const unicodedSearchQuery = searchQuery?.replace(/[+]/gi, '%2b') || "";
    const url = `${Environment.getEnvironmentForMainAPI(this.props.navigatorStore.environment)}/api/${this.props.navigatorStore.tenant}/${this.props.navigatorStore.selectedPhonebook.siteCollection}/phonebook/token/${this.props.navigatorStore.token}?searchQuery=${unicodedSearchQuery}&resultSource=${resultSource}&rowLimit=${this.rowLimit}&startRow=${row === 0 ? 0 : row + 1}`;
    const result: { people: IPeopleInfo[], searchQuery: string, status: number } = await PhonebookService.getPhonebook(url, this.props.navigatorStore.token);
    const isLastSearchedRequest = result.searchQuery === this.state.searchQuery;
    let data = result?.people && result.people.length > 0 ? result.people : [];
    if (row !== 0) {
      //The getPhonebook call might return people/persons that are already received in a previous call (even when using the startRow to skip items)
      //Therefore we use a filter on the newly received dataset which removes all the people that are already in state which have the same "Path" property value
      //The "Path" property value is ensured to be unique, as this is the given item's URL path
      const duplicatePersonsRemoved = data.filter(person => {
        const personPath = person.properties.find(p => p.property === "Path")?.value;
        if (!personPath) return false;

        const isDuplicate = this.state.content.some(existingPerson =>
          existingPerson.properties.find(prop => prop.property === "Path")?.value === personPath
        );

        return !isDuplicate;
      });

      data = this.state.content.concat(duplicatePersonsRemoved);
    }
    if (this.props.navigatorStore.selectedPhonebook !== undefined) {
      if ((searchQuery === undefined || isLastSearchedRequest) && result.status === 200) {
        this.setState({
          errorFetching: false,
          content: data,
          searchQuery: searchQuery,
          isLoading: false,
          loadingMore: false,
          hasAllPeople: result && result.people.length < this.rowLimit
        });
      } else {
        if (result.status !== 200) {
          this.setState({
            errorFetching: true,
            isLoading: false,
            loadingMore: false,
            searchQuery: searchQuery,
          });
        }
      }
    }
  }

  private closePhonebook = () => {
    this.props.navigatorStore.selectedPhonebook = undefined;
    this.props.navigatorStore.selectTopMenuItem(undefined);
    this.setState({ content: [], hasAllPeople: false, errorFetching: false });
    document.body.style.overflowY = "auto";
    document.body.style.height = "inherit";
  }

  // On scroll through users
  private onScroll = (event: React.UIEvent<HTMLDivElement>) => {
    if (!this.state.isLoading && !this.state.loadingMore && !this.state.errorFetching) {
      if (event.currentTarget.offsetHeight + Math.floor(event.currentTarget.scrollTop) >= (event.currentTarget.scrollHeight - 1) && !this.state.hasAllPeople) {
        this.search(this.state.searchQuery, this.state.content.length);
      }
    }
  }

  public render() {
    let table: JSX.Element;
    table = (
      <div
        className={styles.phonebookContent}
        style={{
          height: new ConditionalOutput(this.props.navigatorStore.contentHeight)
            .OnCondition(Helper.getDisplayEnvironment() === 'Sharepoint', this.props.navigatorStore.contentHeight - 120)
            .Last()
        }}
        onScroll={event => this.onScroll(event)}
      >
        {
          this.state.content.length !== 0 &&
          this.state.content.map(
            (info: IPeopleInfo, index): JSX.Element => {
              return (
                <div
                  key={"peopleCard" + index}
                  className={styles.peopleCardDiv}>
                  <PeopleCard
                    index={index}
                    properties={this.getPropertiesForPeopleCard(info.properties)}
                    image={info.image}
                    linkedTextColor={window.__themeState__?.theme?.themePrimary ? window.__themeState__?.theme?.themePrimary : this.props.navigatorStore.highlightColor}
                    backgroundColor={window.__themeState__?.theme?.themePrimary}
                    tenant={this.props.navigatorStore.tenant}
                    highlightColor={this.props.navigatorStore.highlightColor}
                    fontSlots={this.props.navigatorStore.fontSlots}
                  />
                </div>
              );
            }
          )
        }
        {this.state.errorFetching &&
          <div className={styles.errorFetchingDiv}>
            <div className={styles.errorFetchingText}>
              {new LocalizationService().strings.Phonebook_ErrorFetching}
            </div>
            <IAButton
              label={new LocalizationService().strings.Phonebook_Retry}
              borderRadius={5}
              buttonColor={this.props.navigatorStore.highlightColor}
              textColor={"#ffffff"}
              onClick={() => {
                this.setState({ errorFetching: false });
                this.search(this.state.searchQuery, this.state.content.length);
              }}
            />
          </div>
        }
        {this.state.loadingMore &&
          <IASpinner color={this.props.navigatorStore.highlightColor} />
        }
      </div>
    );
    let top = 0;
    if ((Helper.getDisplayEnvironment() === "Sharepoint" || Helper.getDisplayEnvironment() === "SharepointClassic") && document.getElementById("IA_navigator_bar") != undefined && document.getElementById("IA_navigator_vertical_menu") == undefined) {
      top = 48;
    }
    return (
      <div id="phonebook">
        <IAPanel
          close={() => this.props.navigatorStore.selectedPhonebook = undefined}
          open={!!this.props.navigatorStore.selectedPhonebook}
          showNavigationBar={false}
          transition="slide"
          width={this.props.navigatorStore.isMobile ? window.innerWidth : 600}
          marginTop={top}
          backgroundColor="#ffffff"
        >
          <div className={styles.phonebookHeader}>
            <div className={styles.phonebookTitleCloseWrapper}>
              <div
                className={styles.phonebookTitle}
                style={{
                  fontFamily: this.props.navigatorStore.fontSlots?.heading?.fontFamily
                }}
              >
                {new LocalizationService().strings.Phonebook_Header}
              </div>
              <button
                className={styles.phonebookCloseIcon}
                aria-label="Close"
                onClick={() => {
                  this.closePhonebook();
                }}
              >
                <IAIcon
                  title="Close"
                  size={20}
                  color={"gray"}
                />
              </button>
            </div>
            <div className={styles.phonebookSearch}>
              <IATextField
                placeholder={new LocalizationService().strings.Phonebook_Search}
                autoFocus={this.props.isShowing}
                onChange={(str) => {
                  // Clear previous timeout
                  if (this.searchTimeoutId) {
                    clearTimeout(this.searchTimeoutId);
                  }
                  // Update the search query immediately for UI responsiveness
                  this.setState({ searchQuery: str ?? "" });
                  // Set a new timeout to trigger search after 600ms delay
                  this.searchTimeoutId = setTimeout(() => {
                    this.search(str ?? "");
                  }, 600);
                }}
                text={this.state.searchQuery || ""}
                borderRadius={5}
                highlightColor={this.props.navigatorStore.highlightColor}
                style={{
                  marginTop: 0,
                  marginBottom: 15
                }}
              />
              {/* {
                (this.state.isLoading || this.state.loadingMore) &&
                <div className={styles.loadMoreSpinner} >
                  <IAIcon
                    title="Spinner"
                    size={19}
                    color={window.__themeState__?.theme?.themePrimary}
                  />
                </div>
                } */}
            </div>
          </div>
          {(!this.state.isLoading || this.state.loadingMore) &&
            table
          }
          {this.state.isLoading &&
            (Array.from(Array(3).keys())).map(i => {
              const width = "auto";
              const height = 125;
              return <IASkeleton
                key={i}
                skeleton={{
                  height,
                  width,
                  marginTop: 5,
                  marginRight: 32,
                  marginBottom: 15,
                  marginLeft: 34,
                  borderRadius: 10
                }}
              />
            })}
        </IAPanel >
      </div>
    );
  }


}


